import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'sword', 'Sword', [["path",{"d":"M20 4v5l-9 7l-4 4l-3 -3l4 -4l7 -9z","key":"svg-0"}],["path",{"d":"M6.5 11.5l6 6","key":"svg-1"}]]);